import React, { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, Upload, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";

export default function ExportImport({ module, canImport = true }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const exportData = async () => {
    try {
      const res = await api.get(`/export/${module}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${module}_${new Date().toISOString().slice(0, 10)}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Excel diunduh");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    }
  };

  const exportTemplate = async () => {
    try {
      const res = await api.get(`/export/${module}/template`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `template_${module}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Template diunduh");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    }
  };

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post(`/import/${module}`, fd);
      toast.success(`Import selesai: ${data.inserted} baru, ${data.updated} diperbarui${data.errors?.length ? `, ${data.errors.length} error` : ""}`);
      window.location.reload();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <Button onClick={exportData} data-testid={`export-${module}-btn`} variant="outline" className="rounded-none border-neutral-800 hover:border-[#FF6600] hover:text-[#FF6600] h-11">
        <Download size={14} className="mr-1" /> Export
      </Button>
      {canImport && (
        <>
          <Button onClick={exportTemplate} data-testid={`template-${module}-btn`} variant="outline" className="rounded-none border-neutral-800 hover:border-[#FFD700] hover:text-[#FFD700] h-11">
            <FileSpreadsheet size={14} className="mr-1" /> Template
          </Button>
          <Button onClick={() => fileRef.current?.click()} disabled={uploading} data-testid={`import-${module}-btn`} variant="outline" className="rounded-none border-neutral-800 hover:border-[#16A34A] hover:text-[#16A34A] h-11">
            <Upload size={14} className="mr-1" /> {uploading ? "..." : "Import"}
          </Button>
          <input ref={fileRef} type="file" accept=".xlsx,.xls" hidden onChange={onFile} />
        </>
      )}
    </>
  );
}
